import { render } from "./AdmissionTicket.vue?vue&type=template&id=59f9fbf2&ts=true"
import script from "./AdmissionTicket.vue?vue&type=script&lang=ts"
export * from "./AdmissionTicket.vue?vue&type=script&lang=ts"

import "./AdmissionTicket.vue?vue&type=style&index=0&id=59f9fbf2&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__